// extracted by mini-css-extract-plugin
export default {"ChosenKeywordTable":"chosenKeywordTable_ChosenKeywordTable__lZm4P","bid-price-cell":"chosenKeywordTable_bid-price-cell__hjAcf"};